import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './app/App'
import 'react-datepicker/dist/react-datepicker.css'
import 'overlayscrollbars/overlayscrollbars.css'
import './styles/index.css'
import './styles/datepicker.css'
import { reloadOnStaleChunk } from './app/utils/chunkReload'
import { primeSoundOnFirstGesture } from './app/utils/sound'
import { injectDesignTokenCssVariables } from './app/config/designTokens'
import { Capacitor } from '@capacitor/core'

// Main entry point for web app

// Бренд-переменные из общего пакета дизайн-токенов (web + mobile) — до рендера.
injectDesignTokenCssVariables()

// Нативная обёртка (Capacitor APK): системные бары уже учтены нативно — на WebView < 140
// SystemBars паддит сам WebView под статус-баром, на >= 140 env(safe-area-inset-*) честный.
// CSS-пол `.safe-top` (24px, theme.css) там — второй резерв поверх нативного, пустая полоса
// над шапкой (Ирина, 01.10). Класс ставим до первого рендера, чтобы шапка не прыгала.
if (Capacitor.isNativePlatform()) {
  document.documentElement.classList.add('rla-native')
}

// Авто-перезагрузка при «протухшем» чанке. После нового деплоя старая вкладка
// ссылается на исчезнувший lazy-чанк (напр. секции лендинга) → «Failed to fetch
// dynamically imported module». Перезагрузка подтягивает свежий index.html с новыми
// хэшами.
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault()
  reloadOnStaleChunk()
})

window.addEventListener('unhandledrejection', (event) => {
  const msg = String(event?.reason?.message || event?.reason || '')
  if (/dynamically imported module|Importing a module script failed|error loading dynamically/i.test(msg)) {
    reloadOnStaleChunk()
  }
})

// Прогрев звука на первом касании экрана. Именно здесь, а не в useEffect в App:
// браузер не даёт создать «живой» AudioContext до жеста пользователя, а эффекты
// в React.StrictMode вызываются дважды — на уровне модуля подписка ставится ровно
// один раз и снимается сама после первого жеста.
primeSoundOnFirstGesture()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
